import { removeAndCleanLink } from "@/utils/helper"
import { findItemByName } from "./navigationHelper"

const LANGUAGE_PROPERTY_MAPPINGS = [
  {
    nameKey: "languageOne",
    abbreviationKey: "languageOneAbbreviation",
    linkKey: "languageOneLink",
  },
  {
    nameKey: "languageTwo",
    abbreviationKey: "languageTwoAbbreviation",
    linkKey: "languageTwoLink",
  },
  {
    nameKey: "languageThree",
    abbreviationKey: "languageThreeAbbreviation",
    linkKey: "languageThreeLink",
  },
]

const createLanguageObject = (language, abbreviation, link, width) => {
  if (!language) return null
  const sanitizedLink = removeAndCleanLink(link)
  return {
    text: width < 1024 ? language : abbreviation,
    href: sanitizedLink,
    trackingAttributes: {
      "data-datalayer-id": "kds-element-navigation",
      "data-datalayer-data": JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "language selector",
        eventName: "language selector",
        eventType: "language selector",
        internalLinkName: `language select:${abbreviation.toLowerCase()}`,
        internalLinkPosition: "languageselector",
        internalLinkType: "homepage:navigation",
        internalLinkURL: sanitizedLink,
        internalLinkZoneName: "home:global header",
      }),
    },
  }
}

const mapRegion = (
  regionName = "",
  items = [],
  currentCountry = "",
  width = 0
) => {
  return {
    name: regionName,
    countries: items
      .map(item => {
        if (!item.countryName && !item.country) return null
        const country = { name: item.countryName || item.country }
        const languages = LANGUAGE_PROPERTY_MAPPINGS.map(
          ({ nameKey, abbreviationKey, linkKey }) =>
            createLanguageObject(
              item[nameKey],
              item[abbreviationKey],
              item[linkKey],
              width
            )
        ).filter(Boolean)

        if (item.countryLink) {
          country.href = removeAndCleanLink(item.countryLink)
          country.trackingAttributes = {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
              clickInternalLinks: "true",
              eventAction: "country selector",
              eventName: "country selector",
              eventType: "country selector",
              internalLinkName: `country select:${item.country.toLowerCase()}`,
              internalLinkPosition: "global header",
              internalLinkType: "homepage:navigation",
              internalLinkURL: "n/a",
              internalLinkZoneName: "home:global header",
            }),
          }
        }
        if (item.countryName === currentCountry) country.isCurrentCountry = true
        if (languages.length) country.languages = languages

        return country
      })
      .filter(Boolean),

    trackingAttributes: {
      "data-datalayer-id": "kds-element-navigation",
      "data-datalayer-data": JSON.stringify({
        clickInternalLinks: "true",
        eventAction: `country select:${regionName.toLowerCase()}`,
        eventName: `country select:${regionName.toLowerCase()}`,
        eventType: "navigation",
        internalLinkName: regionName.toLowerCase(),
        internalLinkPosition: "countryselector",
        internalLinkType: "global header : navigation",
        internalLinkURL: "n/a",
        internalLinkZoneName: "global header",
      }),
    },
  }
}

export const getLanguageMenu = (container, width) => {
  let secondLanguageCTA = {}
  const {
    country = "",
    language = "",
    enableLanguageSwitcher,
    languageLabel = "",
    languageUrl = "",
  } = container || {}

  const currentCountry = process.env.NEXT_PUBLIC_COUNTRYNAME || country
  const currentLanguage = language || process.env.NEXT_PUBLIC_LANGUAGENAME
  const countrySelector = findItemByName(container, "countryselector")
  if (!countrySelector) {
    return {
      regions: [],
      languageMenuTitle: undefined,
      languageMenuDescription: undefined,
      currentCountry,
      currentLanguage,
      secondLanguageCTA,
    }
  }

  const regionMappings = [
    { key: "americasItems", name: "Americas" },
    { key: "africaItems", name: "Africa" },
    { key: "asiaItems", name: "Asia" },
    { key: "oceaniaItems", name: "Australasia" },
    { key: "middleEastItems", name: "Middle East" },
    { key: "europeItems", name: "Europe" },
  ]

  const regions = regionMappings
    .filter(region => countrySelector[region.key])
    .map(region =>
      mapRegion(region.name, countrySelector[region.key], currentCountry, width)
    )

  if (enableLanguageSwitcher) {
    secondLanguageCTA = {
      text: languageLabel,
      href: removeAndCleanLink(languageUrl),
    }
  }

  return {
    regions,
    languageMenuTitle: countrySelector.title,
    languageMenuDescription: countrySelector.description,
    currentCountry,
    currentLanguage,
    secondLanguageCTA,
  }
}
